import {
    DataTableCustomized,
    FilterBar,
} from '@/components/ui/data-table-customized'
import Paper from '@/components/Paper'
import Statistical from './Statistical'
import { useInvoiceList } from '@/modules/Invoice/hooks/use-invoice-list'
import { useInvoiceListTour } from '@/modules/Invoice/hooks/use-invoice-list-tour'
import { useInvoiceListQuickHelp } from '@/modules/Invoice/hooks/use-invoice-list-quick-help'
import { useTourHandler } from '@/contexts/tour-handler'
import { useEffect } from 'react'

const Index = () => {
    const {
        invoices,
        pagination,
        stateComponent,
        isFetching,
        params,
        queryParams,
        searchInputProps,
        control,
        setFilter,
        columns,
        filterItems,
        handleSortChange,
        handlePageChange,
        handlePageSizeChange,
        t,
    } = useInvoiceList()

    // Tour hooks
    const { startTour } = useInvoiceListTour('index')
    const { registerHandler, unregisterHandler } = useTourHandler()

    // Quick help hook
    useInvoiceListQuickHelp('index')

    // Register tour handler
    useEffect(() => {
        registerHandler(startTour)
        return () => unregisterHandler()
    }, [registerHandler, unregisterHandler, startTour])

    return (
        <div className="space-y-2" data-tour="invoice-list">
            {/* Statistical Component */}
            <Paper className="mt-2" data-tour="invoice-statistical">
                <Statistical params={queryParams} />
            </Paper>

            {/* Filters and Data Table */}
            <Paper>
                <div data-tour="invoice-filter-bar">
                    <FilterBar
                        control={control}
                        setFilter={setFilter}
                        items={filterItems}
                        hideSearch
                    />
                </div>
                {stateComponent || (
                    <div data-tour="invoice-data-table">
                        <DataTableCustomized
                            columns={columns}
                            rows={invoices}
                            rowKey={(row) => row.invoice_id}
                            resizable
                            loading={isFetching && !invoices.length}
                            isFetching={isFetching}
                            emptyMessage={t('no-invoices', {
                                defaultValue: 'Không có hóa đơn nào',
                            })}
                            sorting={{
                                sortBy: params.sort_by,
                                sortOrder: params.sort_order,
                                onSortChange: handleSortChange,
                            }}
                            pagination={
                                pagination
                                    ? {
                                          page: params.page || 1,
                                          pageSize: params.page_size || 20,
                                          total: pagination.total || 0,
                                          onPageChange: handlePageChange,
                                          onPageSizeChange:
                                              handlePageSizeChange,
                                          pageSizeOptions: [10, 20, 50, 100],
                                      }
                                    : undefined
                            }
                            toolbar={{
                                search: {
                                    ...searchInputProps,
                                    placeholder: t('search-invoice', {
                                        defaultValue: 'Tìm kiếm hóa đơn...',
                                    }),
                                    tourId: 'invoice-search',
                                },
                                settings: {
                                    show: true,
                                    storageKey: 'invoice-list',
                                    tourId: 'invoice-settings',
                                },
                            }}
                        />
                    </div>
                )}
            </Paper>
        </div>
    )
}

export default Index
